function SizeGuideModal() {
	this.wrap = document.querySelector(".js-size-guide-modal-wrap")
	this.modal = document.querySelector(".js-size-guide-modal")
	this.layer = document.querySelector(".js-size-guide-layer")
	this.openers = document.querySelectorAll(".js-size-guide-open")
	this.closers = document.querySelectorAll(".js-size-guide-close")
	this.tabs = document.querySelectorAll(".js-size-guide-tab")
	this.contents = document.querySelectorAll(".js-size-guide-modal-content")

	this.isOpen = false
	this.isAnimating = false
	this.activeTab = "woman"

	var self = this

	this.init = function () {
		if (this.openers.length) {
			for (var i = 0; i < this.openers.length; i++) {
				this.openers[i].addEventListener("click", self.onOpen)
			}
		}
		if (this.closers.length) {
			for (var i = 0; i < this.closers.length; i++) {
				this.closers[i].addEventListener("click", self.onClose)
			}
		}

		if (this.tabs.length) {
			for (var i = 0; i < this.tabs.length; i++) {
				this.tabs[i].addEventListener("click", self.onTabClick.bind(this))
			}
		}

		self.close(true)
	}

	this.onOpen = function () {
		self.open()
	}

	this.onClose = function () {
		self.close()
	}

	this.open = function () {
		if (!self.isAnimating) {
			self.isAnimating = true

			document.body.classList.add("is-size-guide-open")

			self.wrap.style.zIndex = "9999"
			self.wrap.style.opacity = "1"
			self.wrap.style.pointerEvents = "auto"

			self.wrap.setAttribute("aria-hidden", "false")
			self.wrap.setAttribute("tabindex", "-1")
			setTimeout(function () {
				self.wrap.focus()
			}, 10)

			self.modal
				.animate(
					[
						{ opacity: 0, transform: "translateY(40px)" },
						{ opacity: 1, transform: "translateY(0)" },
					],
					{
						duration: 300,
						easing: "cubic-bezier(.4,0,.2,1)",
						fill: "forwards",
					}
				)
				.finished.then(function () {
					self.isOpen = true
					self.isAnimating = false
					self.enableGlobalListeners()
				})
		}
	}

	this.close = function (immediate) {
		if (!self.isAnimating) {
			self.isAnimating = true

			document.body.classList.remove("is-size-guide-open")

			self.modal
				.animate(
					[
						{ opacity: 1, transform: "translateY(0)" },
						{ opacity: 0, transform: "translateY(40px)" },
					],
					{
						duration: immediate ? 0 : 300,
						easing: "cubic-bezier(.4,0,.2,1)",
						fill: "forwards",
					}
				)
				.finished.then(function () {
					self.wrap.style.zIndex = "-1"
					self.wrap.style.opacity = "0"
					self.wrap.style.pointerEvents = "none"

					self.isOpen = false
					self.isAnimating = false
					self.disableGlobalListeners()

					self.wrap.setAttribute("aria-hidden", "true")
				})
		}
	}

	this.onTabClick = function (e) {
		var selectedTab = e.currentTarget.getAttribute("data-tab")
		if (selectedTab === this.activeTab) return

		this.activeTab = selectedTab

		// Update tabs
		if (this.tabs.length) {
			for (var i = 0; i < this.tabs.length; i++) {
				if (this.tabs[i].getAttribute("data-tab") === selectedTab) {
					this.tabs[i].classList.add("is-active")
				} else {
					this.tabs[i].classList.remove("is-active")
				}
			}
		}

		// Update contents
		if (this.contents.length) {
			for (var i = 0; i < this.contents.length; i++) {
				if (this.contents[i].getAttribute("data-content") === selectedTab) {
					this.contents[i].classList.add("is-active")
				} else {
					this.contents[i].classList.remove("is-active")
				}
			}
		}
	}

	this.keyupHandler = function (e) {
		if (e.key === "Escape" || e.keyCode === 27) {
			self.onClose(e)
		}
	}

	this.enableGlobalListeners = function () {
		document.addEventListener("keyup", self.keyupHandler)
	}

	this.disableGlobalListeners = function () {
		document.removeEventListener("keyup", self.keyupHandler)
	}

	if (this.wrap && this.openers.length && this.closers.length) {
		this.init()
	}
}

var sizeGuideModal = new SizeGuideModal()
